export const dragStyles = {
    elastic: 'elastic',
    smooth: 'smooth',
};
export const indicatorTrackStyles = {
    continuous: 'continuous',
    segmented: 'segmented',
};
export const sliderColors = {
    dark: 'dark',
    green: 'green',
};
export const steppingStyles = {
    markers: 'markers',
    segments: 'segments',
};
